import { render, staticRenderFns } from "./QuizPagination.vue?vue&type=template&id=8e0bb7b2&scoped=true&"
import script from "./QuizPagination.vue?vue&type=script&lang=js&"
export * from "./QuizPagination.vue?vue&type=script&lang=js&"
import style0 from "./QuizPagination.vue?vue&type=style&index=0&id=8e0bb7b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0bb7b2",
  null
  
)

export default component.exports